import VisionDiverse from './visionDiverse/VisionDiverse'
import VisionEnhance from './visionEnhance/VisionEnhance'
import VisionExpert from './visionExpert/VisionExpert'
import VisionHelp from './visionHelp/VisionHelp'
import VisionHero from './visionHero/VisionHero'
import VisionService from './visionService/VisionService'
import VisionTestimonial from './visionTestimonial/VisionTestimonial'
import VisionUnlock from './visionUnlock/VisionUnlock'

export default function Vision() {
  return (
    <div>
        <VisionHero/>
        <VisionUnlock/>
        <VisionExpert/>
        <VisionEnhance/>
        <VisionHelp/>
        <VisionDiverse/>
        <VisionTestimonial/>
        <VisionService/>
    </div>
  )
}
